'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = encryptedLocalStorage;

var _sjcl = require('sjcl');

var _sjcl2 = _interopRequireDefault(_sjcl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function encryptedLocalStorage(password) {
  var encrypt = function encrypt(data) {
    return data ? _sjcl2.default.encrypt(password, data.toString()) : null;
  };
  var decrypt = function decrypt(data) {
    return data ? _sjcl2.default.decrypt(password, data) : null;
  };

  return {
    getItem: function getItem(key) {
      return decrypt(window.localStorage.getItem(key));
    },
    setItem: function setItem(key, value) {
      window.localStorage.setItem(key, encrypt(value));
    },
    removeItem: function removeItem(key) {
      window.localStorage.removeItem(key);
    }
  };
}
//# sourceMappingURL=encryptedLocalStorage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/misc/encryptedLocalStorage.js
// module id = 632
// module chunks = 0